import { FormatDate, formatDate } from '@shared/lib/date/formatDate'

export const getFormatDate = (date: FormatDate) => (date ? formatDate(date, 'DD.MM.YYYY HH:MM') : '')
